export default "__VITE_ASSET__DXVb99dr__";